export default __webpack_public_path__ + "static/media/70.c85bbe45.gif";